    //头部和底部导航条
    export const navList = [{
            isShow: false,
            active: false,
            name: '首页',
            enName: 'Home',
            miniNav: [{
                name: '首页',
                link: 'https://www.cmgos.com/web/home'
            }]
        },
        {
            isShow: false,
            active: false,
            name: '新闻中心',
            enName: 'NEWS CENTER',
            miniNav: [{
                name: '公司新闻',
                // link: 'https://www.cmgos.com/web/news/internal'
                link: 'https://www.cmgos.com/web/news_center/industry_dynamic/'
            }]
        },
        {
            isShow: false,
            active: true,
            name: '产品与服务',
            enName: 'PRODUCTS & SERVICES',
            miniNav: [{
                    name: '产品介绍',
                    link: 'https://www.cmgos.com/web/product/overview'
                },
                {
                    name: '文档中心',
                    link: 'https://document.cmgos.com/'
                },
                {
                    name: '授权与下载',
                    link: 'https://download.cmgos.com/'
                },
                {
                    name: '服务介绍',
                    link: 'https://www.cmgos.com/web/product/service'
                },
                {
                    name: '支持服务',
                    link: 'https://support.cmgos.com/'
                }
            ]
        },
        {
            isShow: false,
            active: false,
            name: '合作伙伴',
            enName: 'PARTNERS',
            miniNav: [
                {
                    name: "渠道合作伙伴",
                    link: "https://www.cmgos.com/web/partner/channel/"
                },
                {
                    name: "行业应用合作伙伴",
                    link: "https://www.cmgos.com/web/partner/isv/"
                },
                {
                    name: '处理器厂商',
                    link: 'https://www.cmgos.com/web/partner/processor'
                },
                {
                    name: 'OEM厂商',
                    link: 'https://www.cmgos.com/web/partner/oem'
                },
                {
                    name: '安全厂商',
                    link: 'https://www.cmgos.com/web/partner/security'
                },
                {
                    name: '办公软件厂商',
                    link: 'https://www.cmgos.com/web/partner/oa'
                },
                {
                    name: '产品兼容性认证',
                    link: 'https://compcert.cmgos.com/'
                }
            ]
        },
        {
            isShow: false,
            active: false,
            name: '关于我们',
            enName: 'ABOUT US',
            miniNav: [{
                    name: '公司简介',
                    link: 'https://www.cmgos.com/web/about-us/intro'
                },
                {
                    name: '大事记',
                    link: 'https://www.cmgos.com/web/about-us/milestone'
                },
                {
                    name: '企业文化',
                    link: 'https://www.cmgos.com/web/about-us/culture'
                },
                // {
                //     name: '管理团队',
                //     link: 'https://www.cmgos.com/web/about-us/manage'
                // },
                {
                    name: '所获荣誉',
                    link: 'https://www.cmgos.com/web/about-us/honours'
                },
                {
                    name: '联系我们',
                    link: 'https://www.cmgos.com/web/about-us/contact'
                }
            ]
        },
        {
            isShow: false,
            active: false,
            name: '加入我们',
            enName: 'JOIN US',
            miniNav: [{
                name: '招聘信息',
                link: 'http://www.cmgos.com/web/join-us/recruit'
            }]
        },
        {
            isShow: false,
            active: false,
            name: '中文(中国)',
            enName: 'ENGLISH',
            miniNav: [
              {
                name: '中文(中国)',
                link: 'https://www.cmgos.com/web/home/'
              },
              {
                name: 'ENGLISH',
                link: 'https://www.cmgos.com/web/home_en'
              }
            ]
          }

    ];



// WEBPACK FOOTER //
// ./src/util/public.js